<template>
  <div id="app" ref='outerDom' @scroll="handleScroll">
    <Nav v-if="falg"></Nav>
    <router-view />
    <Footer v-if="falg" />
    <el-backtop target="#app" :bottom="100">
  </el-backtop>
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from "@/components/Nav.vue";
import Footer from '@/components/Footer.vue'

export default {
  components: {
    Nav,
    Footer
  },
  data(){
    return{
       falg:true,
    }
  },
  watch:{
    '$route': {
      handler: function (to, from) {
        console.log(to,from)
        this.$refs.outerDom.scrollTop = 0
      }
}
  },
  created () {
    if(this.$route.path=='/swiper/index'){
      this.falg=false
    }

  },
  mounted(){
    var that = this
    this.$bus.$on('clearKeyword',(e)=>{
      console.log(e,that.$refs.outerDom)
      that.$refs.outerDom.scrollTo({
          top: e,
          behavior: 'smooth'
        });
    })
  },
  methods:{
    handleScroll(){
      // console.log(e.target.scrollTop)
    }
  }

};
</script>

<style lang="scss">
ul,
p,
body {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
  color: #000;
}
#app {
  width:100vw;
  height:100vh;
  overflow-y: scroll;
  .Nav-hader {
    height:100%;
    padding: 0;
  }
}
</style>
